import { Action } from '@ngrx/store';
import {EventMonitoringFilter, Events} from '../../../models/events';

export enum EventMonitoringActionTypes {
  LoadEventMonitorings = '[EventMonitoring] Load EventMonitorings',
  GetEventMonitorings =  '[EventMonitoring] Get EventMonitorings',
  GetEventMonitoringsFail = '[EventMonitoring] Get EventMonitorings Fail',
}

export class LoadEventMonitorings implements Action {
  readonly type = EventMonitoringActionTypes.LoadEventMonitorings;
  constructor(public payload: Events[]) {}
}

export class GetEventMonitoring implements Action {
  readonly type = EventMonitoringActionTypes.GetEventMonitorings;
  constructor(public payload: EventMonitoringFilter) {}
}

export class GetEventMonitoringFail implements Action {
  readonly type = EventMonitoringActionTypes.GetEventMonitoringsFail;
}

export type EventMonitoringActions = LoadEventMonitorings
  | GetEventMonitoring
  | GetEventMonitoringFail;
